/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import LegalLayout from "./LegalLayout";
import Seo, { breadcrumbTrail } from "../components/dmb/Seo";

export default function MentionsLegales() {
    return (
        <LegalLayout
            testid="mentions-legales"
            kicker="Informations légales"
            title="Mentions légales"
            lastUpdate="16 octobre 2026"
        >
            <Seo
                title="Mentions légales | DMB Partners"
                description="Mentions légales du site DMB Partners : éditeur, immatriculation ORIAS, assurance responsabilité civile professionnelle, médiation et hébergement."
                path="/mentions-legales"
                jsonLd={breadcrumbTrail([
                    { name: "Accueil", path: "/" },
                    { name: "Mentions légales", path: "/mentions-legales" },
                ])}
            />
            <p>
                Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21
                juin 2004 pour la confiance dans l'économie numérique (LCEN), il
                est porté à la connaissance des utilisateurs et visiteurs
                (ci-après l'« Utilisateur ») du site{" "}
                <a href="https://www.dmbpartners.fr">www.dmbpartners.fr</a>{" "}
                (ci-après le « Site ») les présentes mentions légales.
            </p>
            <p>
                La connexion et la navigation sur le Site par l'Utilisateur
                impliquent l'acceptation intégrale et sans réserve des présentes
                mentions légales.
            </p>

            <h2>Article 1 — Éditeur du Site</h2>
            <p>
                Le Site est édité par <strong>DMB PARTNERS</strong>, société par
                actions simplifiée (SAS) au capital de 1 000 euros, immatriculée
                au Registre du Commerce et des Sociétés de Paris sous le numéro{" "}
                <strong>928 053 487</strong>, dont le siège social est situé au{" "}
                <strong>149 avenue du Maine, 75014 Paris</strong>.
            </p>
            <ul>
                <li>
                    Adresse e-mail :{" "}
                    <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>
                </li>
                <li>N° de TVA intracommunautaire : <strong>FR28928053487</strong></li>
                <li>Directeur de la publication : <strong>Hugo DAUGERON-MIJOIN</strong></li>
            </ul>
            <p>Ci-après l'« Éditeur ».</p>

            <h2>Article 2 — Statut réglementaire (IOBSP)</h2>
            <p>
                DMB PARTNERS est immatriculée au{" "}
                <strong>Registre unique des intermédiaires en assurance, banque et finance (ORIAS)</strong>{" "}
                sous le numéro <strong>25003576</strong>, en qualité de{" "}
                <strong>Courtier en opérations de banque et en services de paiement (COBSP)</strong>.
                Cette immatriculation peut être vérifiée sur le site{" "}
                <a href="https://www.orias.fr" target="_blank" rel="noopener noreferrer">www.orias.fr</a>.
            </p>
            <p>
                DMB PARTNERS exerce son activité d'intermédiation en opérations de
                banque et en services de paiement conformément aux articles L.
                519-1 et suivants et R. 519-1 et suivants du Code monétaire et
                financier. Elle n'est soumise à aucune obligation contractuelle de
                travailler exclusivement avec un ou plusieurs établissements de
                crédit ou de paiement. La liste des établissements avec lesquels
                DMB PARTNERS entretient des relations d'affaires est communiquée
                sur simple demande.
            </p>
            <p>
                <strong>Autorité de contrôle :</strong> Autorité de Contrôle
                Prudentiel et de Résolution (ACPR), 4 place de Budapest, CS 92459,
                75436 Paris Cedex 09 –{" "}
                <a href="https://acpr.banque-france.fr" target="_blank" rel="noopener noreferrer">acpr.banque-france.fr</a>.
            </p>

            <h2>Article 3 — Association professionnelle</h2>
            <p>
                DMB PARTNERS est adhérente de l'association <strong>Endya</strong>,
                association professionnelle de courtiers agréée par l'Autorité de
                Contrôle Prudentiel et de Résolution, au titre de son activité de
                Courtier en opérations de banque et en services de paiement (COBSP).
                Endya – 10 rue Auber, 75009 Paris –{" "}
                <a href="https://www.endya.fr" target="_blank" rel="noopener noreferrer">www.endya.fr</a>.
            </p>

            <h2>Article 4 — Assurance responsabilité civile professionnelle</h2>
            <p>
                Conformément aux articles L. 519-3-4 et R. 519-16 du Code
                monétaire et financier, DMB PARTNERS est titulaire d'une assurance
                de responsabilité civile professionnelle souscrite auprès de AIG
                Europe SA – Succursale pour la France, Tour CBX – 1 Passerelle des
                Reflets, 92400 Courbevoie. Police n° <strong>RD01980840X</strong>.
            </p>

            <h2>Article 5 — Liens financiers et rémunération</h2>
            <p>
                DMB PARTNERS ne détient aucune participation, directe ou
                indirecte, supérieure à 10 % des droits de vote ou du capital
                d'un établissement de crédit ou de paiement. Aucun établissement
                de crédit ou de paiement ne détient de participation supérieure à
                10 % des droits de vote ou du capital de DMB PARTNERS.
            </p>
            <p>
                DMB PARTNERS est rémunérée <strong>exclusivement</strong> par des
                honoraires versés par ses clients. Elle ne perçoit aucune
                rémunération ni commission de la part des établissements de crédit
                ou de paiement. DMB PARTNERS ne perçoit aucun fonds destiné à des
                établissements de crédit ou à ses clients, en dehors de sa propre
                rémunération.
            </p>

            <h2>Article 6 — Réclamations et médiation</h2>
            <p>
                Toute réclamation peut être adressée à DMB PARTNERS par e-mail à{" "}
                <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a> ou
                par courrier : DMB PARTNERS – Service Réclamations – 149 avenue
                du Maine, 75014 Paris.
            </p>
            <p>
                DMB PARTNERS s'engage à accuser réception de toute réclamation
                dans un délai maximal de <strong>dix (10) jours ouvrables</strong>{" "}
                à compter de sa réception, et à y apporter une réponse dans un
                délai maximal de <strong>deux (2) mois</strong> à compter de sa
                réception.
            </p>
            <p>
                En cas de désaccord avec la réponse apportée, ou en l'absence de
                réponse dans ces délais, le client ayant la qualité de
                consommateur peut saisir gratuitement le médiateur désigné par
                l'association Endya au titre de l'activité de courtier en
                opérations de banque et en services de paiement :{" "}
                <strong>ANM Conso</strong>, 2 rue de Colmar, 94300 Vincennes –{" "}
                <a href="mailto:contact@anmconso.com">contact@anmconso.com</a>.
            </p>

            <h2>Article 7 — Hébergeur</h2>
            <p>
                Le Site est hébergé par <strong>Emergent Labs Inc.</strong>, dont
                le siège social est situé au 548 Market Street, PMB 75061, San
                Francisco, CA 94104, États-Unis.
            </p>

            <h2>Article 8 — Accès au Site</h2>
            <p>
                Le Site est accessible en tout endroit, 7j/7, 24h/24, sauf cas
                de force majeure, interruption programmée ou non, notamment pour
                des nécessités de maintenance. En cas de modification,
                d'interruption ou de suspension du Site, l'Éditeur ne saurait
                être tenu responsable.
            </p>

            <h2>Article 9 — Protection des données personnelles</h2>
            <p>
                Les traitements de données personnelles réalisés à partir du
                Site sont décrits dans la{" "}
                <Link to="/confidentialite">politique de confidentialité</Link>{" "}
                et la <Link to="/cookies">politique cookies</Link> de DMB
                PARTNERS. Ces documents précisent les données collectées, leurs
                finalités, leurs durées de conservation, ainsi que les droits
                dont vous disposez (accès, rectification, effacement,
                opposition) et les modalités pour les exercer auprès de{" "}
                <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>.
            </p>

            <h2>Article 10 — Propriété intellectuelle</h2>
            <p>
                L'ensemble des éléments du Site (textes, graphismes, logos,
                images, structure) est la propriété exclusive de DMB PARTNERS,
                sauf mention contraire. Toute utilisation, reproduction,
                diffusion, commercialisation ou modification de tout ou partie du
                Site, sans autorisation préalable de l'Éditeur, est prohibée et
                pourra entraîner des actions et poursuites judiciaires, telles
                que notamment prévues par le Code de la propriété intellectuelle
                et le Code civil.
            </p>
        </LegalLayout>
    );
}
